import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AppViewMode } from '@/enums/app-view-mode.enums';

interface AppViewModeStore {
  viewMode: AppViewMode;
  setViewMode: (viewMode: AppViewMode) => void;
}

function isAppViewMode(value: unknown): value is AppViewMode {
  return Object.values<unknown>(AppViewMode).includes(value);
}

function getPersistedViewMode(persistedState: unknown) {
  if (
    !persistedState ||
    typeof persistedState !== 'object' ||
    !('viewMode' in persistedState)
  ) {
    return undefined;
  }

  return isAppViewMode(persistedState.viewMode)
    ? persistedState.viewMode
    : undefined;
}

export const useAppViewModeStore = create<AppViewModeStore>()(
  persist(
    set => ({
      viewMode: AppViewMode.ICONS,
      setViewMode: viewMode => set({ viewMode }),
    }),
    {
      name: 'user-portal-app-view-mode',
      merge: (persistedState, currentState) => ({
        ...currentState,
        viewMode: getPersistedViewMode(persistedState) ?? currentState.viewMode,
      }),
    }
  )
);
